import { Card, FieldGroup, Text, Flex, CardHeader } from '@pega/cosmos-react-core';

import { DetailsDemo } from '../Details/Details.stories';

export const Details = () => {
  return (
    <Card>
      <CardHeader>
        <Text variant='h2'>Details</Text>
      </CardHeader>

      <Flex container={{ direction: 'column', pad: [1, 2, 2], gap: 2 }}>
        <FieldGroup name='Description' headingTag='h3'>
          <Text as='p'>
            This case is presented as a demonstration of the feature set and capabilities of the
            Constellation design system and the case management UX. All of the data within this demo
            is mock data and it is not meant to represent any actual user data.
          </Text>
        </FieldGroup>
        <DetailsDemo />
      </Flex>
    </Card>
  );
};
